import { isBot } from '$lib/userAgent';

const getStorageEstimate = async () => {
  if (!navigator || !navigator.storage || !navigator.storage.estimate) {
    return null;
  }

  const storageEstimate = await navigator.storage.estimate();
  return storageEstimate;
};

const storageQuotaTest = async () => {
  // 20190818JP
  //    Firefox: returns 2048.
  //    Safari: returns null
  if (!/Chrome/.test(window.navigator.userAgent)) {
    return null;
  }

  const storageEstimate = await getStorageEstimate();

  if (!storageEstimate) {
    return null;
  }

  const quotaEstimate = Math.round(storageEstimate.quota / 1024 / 1024);

  if (quotaEstimate && quotaEstimate < 500) {
    return true;
  }

  return null;
};

const localStorageTest = () => {
  if (!window.localStorage || !/Safari/.test(window.navigator.userAgent)) {
    return null;
  }

  try {
    window.localStorage.setItem('test', 1);
  } catch (e) {
    return true;
  }

  window.localStorage.removeItem('test');
  return null;
};

const dbTest = () => {
  if (/Edge|Chrome/.test(window.navigator.userAgent)) {
    return null;
  }

  if (!/Safari/.test(window.navigator.userAgent)) {
    return null;
  }

  try {
    window.openDatabase(null, null, null, null);
  } catch (_) {
    return true;
  }

  return null;
};

const getIsPrivateBrowsing = async () => {
  // 20210602JP: This isn't reliable enough, removing for now.

  // if (isBot()) {
  //   return false;
  // }

  // if (window.location.search === '?private') {
  //   return true;
  // }

  // const storageTestResult = await storageQuotaTest();
  // const dbTestResult = dbTest();
  // const localStorageTestResult = localStorageTest();

  // if (storageTestResult || dbTestResult || localStorageTestResult) {
  //   return true;
  // }

  return false;
};

export { getIsPrivateBrowsing };
